import api, { unwrap, unwrapList } from './api';
import type { AdminUser } from '../types';

export const usersService = {
  list: (params: { search?: string; company_id?: string; is_active?: string }) =>
    api.get('admin/users', { params }).then((r) => unwrapList<AdminUser>(r).data),
  deactivate: (id: string) => api.post(`admin/users/${id}/deactivate`).then(unwrap<AdminUser>),
  activate: (id: string) => api.post(`admin/users/${id}/activate`).then(unwrap<AdminUser>),
  resetLink: (id: string) => api.post(`admin/users/${id}/reset-password-link`).then(unwrap<{ reset_link: string }>),
};
